import { Stack } from '@chakra-ui/react'

import RightAnswer from '../HelperComponents/RightAnswer'
import WatchVideo from '../HelperComponents/WatchVideo'

const WatchWithType = ({ exercise, ...props }) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={5} 
      flexDirection={['column', 'column', 'row']}
      className='watch-with-type_container'
    >
      <WatchVideo exercise={exercise} />
      <RightAnswer {...props} />
    </Stack>
  )
}

export default WatchWithType
